<template>
  <div>

    <sushi-nav v-if="isSushi"/>

    <shop-header :store-id="storeid" :sushiHub="isSushi" v-if="isSushi" />

    <shop-header v-else :store-id="storeid" />



    <div
        :class="{'background-sushi-blue position-relative' : isSushi}">
      <form @submit.prevent="placeOrder"  class="p-3">
        <div class="container main-container">
          <div class="row">
            <div class="col-sm-7 col-xl-8">
              <div class="bg-white py-4 mb-2 position-relative">
                <payment-indicator
                    v-if="showPaymentIndicator"
                    :is-pending="proccessing"
                    :succeeded="paymentSucceeded"
                    :is-pay-later="placingPayLaterOrder"
                    @hide="hidePaymentIndicator"
                ></payment-indicator>
                <div
                    v-if="!user && viewConfig.LogIn"
                    class="alert alert-primary p-4 mt-4 alert-color mx-4"
                    :class="isSushi && 'curved-15'"
                    :style="isSushi ? desktopStyles.alertInfoBackGroundSushi : desktopStyles.alertInfoBackGround"
                    role="alert"
                >
                  <a
                      href="#"
                      :style="desktopStyles.btn"
                      :class="{'curved-5 montserrat-500 ' : isSushi}"
                      class="btn btn-primary pr-2"
                      @click="setShowOverlay(true)"
                  >{{ $t("message.login") }}</a
                  >
                  <span class="pl-2" :class="{'text-white montserrat-500' : isSushi}">{{
                      $t("message.placeAnOrderAsGuestWithoutCreatingAccount")
                    }}</span>
                </div>

                <div class="p-4 d-flex justify-content-center">
                  <div class="w-85">

                    <div  :class="isSushi && 'd-flex align-items-center '">
                    <h4 v-show="showGettingYourMealMessage()" :class="isSushi&& 'montserrat-700'">
                      {{ $t("message.gettingYourOrder") }}
                    </h4>
                    <div
                        class="btn-group"
                        role="group"
                        aria-label="Basic example"
                    >
                      <button
                          v-if="isEnableTab('pickUp')"
                          :class="isSushi&& 'curved-5 ml-3 montserrat-400 text-white'"
                          :style="btnStyle(isPickup, false)"
                          type="button"
                          class="btn"
                          @click="pickupMode"
                      >
                        {{ $t("message.pickUp") }}
                      </button>
                      <button
                          v-show="isEnableTab('delivery')"
                          :style="btnStyle(isDelivery, false)"
                          type="button"
                          class="btn"
                          @click="deliveryMode"
                      >
                        {{ $t("message.checkoutDelivery") }}
                      </button>
                      <button
                          v-if="isEnableTab('deliverToRoom')"
                          :style="btnStyle(isChargeToRoom, false)"
                          type="button"
                          class="btn"
                          @click="chargeToRoomMode"
                      >
                        {{ $t("message.deliverToRoom") }}
                      </button>
                      <button
                          v-if="isEnableTab('dineIn')"
                          :style="btnStyle(isEatIn, false)"
                          type="button"
                          class="btn"
                          @click="eatInMode"
                      >
                        {{ $t("message.dineIn") }}
                      </button>
                    </div>
                    </div>
                    <pickup-address v-show="showPickupAddress()" :isSushi="isSushi" />
                    <my-detail
                        v-if="!selectedCompany.ChargeToRoom && !isEatIn"
                        ref="myDetails"
                        :edit-model="detailModel"
                        :charge-to-room="selectedCompany.ChargeToRoom"
                        @save-user="saveUser"
                        :for-gift="false"
                        :isSushi="isSushi"
                    />
                    <delivery-address
                        v-if="isDelivery && googleLoaded"
                        ref="deliveryAddress"
                        :edit-model="deliveryAddressModel"
                        :show-estimate="!isPreOrder"
                        @postalCodeUpdate="updatePostalCodeHandler"

                    />
                    <div
                        v-show="!isChargeToRoom && (isDelivery || isPickup)"
                        :class="isSushi && 'montserrat-400'"
                        class="form-row mt-4"
                    >
                      <div
                          class="form-group col-6"
                          v-if="
                        selectedCompany.EnablePreoderForDelivery && isDelivery
                      "
                      >
                        <label class="required">{{
                            $t("message.deliveryDate")
                          }}</label>
                        <date-picker
                            name="deliveryDT"
                            @closed="deliveryDateChanged(deliveryDate)"
                            v-model="deliveryDate"
                            :disabledDates="deliveryDisabledDates"
                            bootstrap-styling
                        ></date-picker>
                      </div>
                      <div
                          class="form-group col-6"
                          v-if="selectedCompany.EnablePreoderForPickup && isPickup"
                      >
                        <label class="required"  :class="isSushi && 'montserrat-400'">{{
                            $t("message.pickupDate")
                          }}</label>
                        <date-picker
                            name="pickupDT"
                            @closed="setPickupTimes(pickupDate, false, selectedPickupTime)"
                            v-model="pickupDate"
                            :disabledDates="pickupDisabledDates"
                            bootstrap-styling
                        ></date-picker>
                      </div>
                      <div
                          v-show="isDelivery && !isDeliveryTimeSlotsEnable"
                          class="form-group col-6"
                      >
                        <label class="required" for="time-select"  :class="isSushi && 'montserrat-400'" >{{
                            $t("message.deliveryTime")
                          }}</label>
                        <select
                            id="time-select"
                            v-model="selectedDeliveryTime"
                            name="deliveryTime"
                            class="form-control"
                            @change="selectedDeliveryTimeChange"
                            v-validate="'required'"
                            :disabled="getDeliveryIsLoading"
                        >
                          <option
                              v-for="(t, index) in dtimes"
                              :key="index"
                              :value="t.time"
                          >
                            {{ t.format }}
                          </option>
                        </select>
                        <div class="invalid-feedback"  :class="isSushi && 'montserrat-400'">
                          {{
                            OOErrors.first("deliveryTime")
                                | inputNameLocale("deliveryTime")
                          }}
                        </div>
                      </div>
                      <div v-show="isPickup" class="form-group col-6">
                        <label class="required" for="time-select"  :class="isSushi && 'montserrat-400'">{{
                            $t("message.pickupTime")
                          }}</label>
                        <select
                            id="time-select"
                            v-model="selectedPickupTime"
                            name="pickupTime"
                            class="form-control"
                            v-validate="'required'"
                        >
                          <option
                              v-for="(t, index) in pickupTimes"
                              :key="index"
                              :value="t.time"
                          >
                            {{ t.format }}
                          </option>
                        </select>
                        <div class="invalid-feedback"  :class="isSushi && 'montserrat-400'">
                          {{
                            OOErrors.first("pickupTime")
                                | inputNameLocale("pickupTime")
                          }}
                        </div>
                      </div>
                    </div>
                    <label
                        v-show="isDelivery && isDeliveryTimeSlotsEnable"
                        class="required"
                        for="time-select"
                        :class="isSushi && 'montserrat-400'"
                    >{{ $t("message.deliveryTime") }}</label
                    >
                    <div
                        v-show="isDelivery && isDeliveryTimeSlotsEnable"
                        class="form-row"
                    >
                      <div
                          class="btn time-slot-btn"
                          style="padding: 4px"
                          v-for="(timeSlot, index) in dtimes.filter(
                        (p) => p.format.indexOf('ASAP') >= 0
                      )"
                          :key="timeSlot + index"
                          @click="
                        selectedDeliveryTime = timeSlot.time;
                        selectedDeliveryTimeChange();
                      "
                          :style="
                        getTimeSlotStyle(selectedDeliveryTime == timeSlot.time)
                      "
                          :disabled="getDeliveryIsLoading"
                      >
                        <span  :class="isSushi && 'montserrat-400'">ASAP</span>
                        <br />
                        <span  :class="isSushi && 'montserrat-400'">{{
                            timeSlot.format.split("(")[1].split(")")[0]
                          }}</span>
                      </div>
                      <button
                          type="button"
                          class="btn time-slot-btn"
                          v-for="(timeSlot, index) in dtimes.filter(
                        (p) => p.format.indexOf('ASAP') < 0
                      )"
                          :key="index"
                          @click="
                        selectedDeliveryTime = timeSlot.time;
                        selectedDeliveryTimeChange();
                      "
                          :style="
                        getTimeSlotStyle(selectedDeliveryTime == timeSlot.time)
                      "
                          :disabled="getDeliveryIsLoading"
                      >
                        {{ timeSlot.format }}
                      </button>
                    </div>
                    <room-delivery
                        v-if="isChargeToRoom"
                        ref="roomDelivery"
                        :edit-model="roomDeliveryModel"
                    />
                    <eat-in
                        ref="eatIn"
                        @save-user="saveUser"
                        v-if="isEatIn"
                        :edit-model="eatInModel"
                        :is-pay-by-card="isPayByCard"
                    ></eat-in>
                    <div>
                      <div class="form-row" v-show="viewConfig.ShowNotes">
                        <div class="form-group col-sm-12">
                          <h4>{{ $t("message.notes") }}</h4>
                          <textarea
                              id="notes"
                              maxlength="300"
                              v-model="notes"
                              name="notes"
                              type="text"
                              class="form-control"
                          />
                        </div>
                      </div>
                    </div>
                    <div v-if="isSushi">
                      <div class="form-row">
                        <div
                            class="d-flex form-group ml-4 col-sm-12 custom-control custom-checkbox"
                            :class="{ shake: turnAcceptLabelToRed }"
                        >
                          <input
                              type="checkbox"
                              id="acceptTerms"
                              class="acceptTerms custom-control-input"
                              name="acceptTerms"
                              v-model="AcceptTermsAndCondition"
                          />
                          <label for="acceptTerms" class="custom-control-label"></label>
                          <div :style="acceptTermsStyle()" :class="isSushi && 'montserrat-400'">
                            I have read and accept the
                            <a
                                @click.prevent="isSushi ? toggleModal() :  showTermsAndCondition()"
                                style="cursor: pointer; text-decoration: underline"
                            >terms and conditions</a
                            >.
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                        :class="isChargeToRoom ? 'mt-4' : 'mt-2'"
                        v-if="showChargeToRoom()"
                    >
                      <payment-type
                          @set-payment-method="setPaymentMethod"
                          @set-show-pay-by-apple="setCanPayByApple"
                          @set-show-pay-by-google="setCanPayByGoogle"
                          :is-pay-by-cash-enable="isPayByCashEnable"
                          :is-pay-by-point-enable="payByPoint.canPay"
                          :card-value-in-point="payByPoint.cardValueInPoint"
                          :value="paymentMethod"
                          :key="PaymenttypeRender"

                      ></payment-type>
                    </div>
                    <div
                        v-if="
                      (canPayByApple || canPayByGoogle) &&
                      (!viewConfig.PayLaterOnly || !isEatIn) &&
                      getTotalPrice > 0
                    "
                        :class="{ disableItem: SelecteDPTime() }"
                    >
                      <google-pay
                          :disabled="getDeliveryIsLoading || addressOutOfService || disableStripeBtn"
                          @finalize="beginStripePayment"
                          @validate="placeOrder"
                          @error="googlePaymentError"
                          @stripe-click="setMethodAndPlaceOrder"
                          @proccessing="updateProcessing"
                          @toggle-payment-indicator="togglePaymentIndicator"
                          @cancel="handlePaymentCancellation"
                          ref="stripePayRef"
                      />
                    </div>
                    <div
                        v-if="
                      canPayByPoints && (!viewConfig.PayLaterOnly || !isEatIn)
                    "
                    >
                      <div id="payment-request-button" class="pt-2 mb-2">
                        <div :class="{ disableItem: SelecteDPTime() }">
                          <div class="row">
                            <div class="col-sm-12">
                              <button
                                  @touchstart="
                                (event) => {
                                  if (orderDisbaled || showDeliveryDistance)
                                    event.preventDefault();
                                }
                              "
                                  :disabled="payButtonsAreDisabled"
                                  type="button"
                                  @click.prevent="setMethodAndPlaceOrder(2)"
                                  class="
                                btn btn-primary btn-lg btn-block
                                mb-2
                                d-flex
                                justify-content-center
                                align-items-center
                              "
                                  :style="orderButtonStyles"
                              >
                                {{ $t("message.payByLoyaltyPoints") }} &nbsp;
                                <span class="payByPoint-span text-success">
                                -{{
                                    Math.ceil(payByPoint.cardValueInPoint)
                                        | formatNumber
                                  }}
                                pts ({{ getTotalPrice | formatMoney(currencySign) }})
                              </span>
                                <span v-show="proccessing && paymentMethod === 2">
                                <i class="spin-sm ml-4" />
                              </span>
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                        v-if="
                      isPayByCashEnable &&
                      (!viewConfig.PayLaterOnly || !isEatIn)
                    "
                    >
                      <div id="payment-request-button" class="pt-2 mb-2">
                        <div :class="{ disableItem: SelecteDPTime() }">
                          <div class="row">
                            <div class="col-sm-12">
                              <button
                                  @touchstart="
                                (event) => {
                                  if (orderDisbaled || showDeliveryDistance)
                                    event.preventDefault();
                                }
                              "
                                  :disabled="payButtonsAreDisabled"
                                  type="button"
                                  @click.prevent="setMethodAndPlaceOrder(3)"
                                  class="
                                btn btn-primary btn-lg btn-block
                                mb-2
                                d-flex
                                justify-content-center
                                align-items-center
                              "
                                  :style="orderButtonStyles"
                              >
                                {{ $t("message.payByCash") }}
                                <span v-show="proccessing && paymentMethod === 3">
                                <i class="spin-sm ml-4" />
                              </span>
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div v-if="!viewConfig.PayLaterOnly || !isEatIn">
                      <payment
                          ref="payment"
                          :can-pay-by-other-than-card="canPayByOtherThanCard"
                          :user="user"
                          :dbuser="userInfo"
                          :edit-model="paymentModel"
                          @save-credit="saveCredit"
                          :isSushi="isSushi"
                      />
                    </div>
                    <div v-if="!viewConfig.PayLaterOnly || !isEatIn">
                      <div id="payment-request-button" class="pt-2 mb-2">
                        <div :class="{ disableItem: SelecteDPTime() }">
                          <div class="row">
                            <div class="col-sm-12">
                              <button
                                  @touchstart="
                                (event) => {
                                  if (orderDisbaled || showDeliveryDistance)
                                    event.preventDefault();
                                }
                              "
                                  :disabled="payButtonsAreDisabled"
                                  type="button"
                                  @click.prevent="setMethodAndPlaceOrder(1)"
                                  :class="isSushi && 'montserrat-700'"
                                  class="
                                btn btn-primary btn-lg btn-block
                                mb-2
                                d-flex
                                justify-content-center
                                align-items-center
                              "

                                  :style="orderButtonStyles"


                              >
                                {{ $t("message.payByCard") }}
                                <span v-show="proccessing && paymentMethod == 1">
                                <i class="spin-sm ml-4" />
                              </span>
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div v-if="canPayLater">
                      <div class="pt-2 mb-2">
                        <div :class="{ disableItem: (SelecteDPTime()) }">
                          <div class="row">
                            <div class="col-sm-12">
                              <button
                                  :disabled="payLaterButtonIsDisabled"
                                  type="button"
                                  @click.prevent="payLaterButtonClicked"
                                  class="
                                btn btn-primary btn-lg btn-block
                                mb-2
                                d-flex
                                justify-content-center
                                align-items-center
                              "
                                  :style="orderButtonStyles"
                              >
                                {{ payLaterButtonText }}
                                <span
                                    v-show="proccessing && (paymentMethod == 8 || paymentMethod == 9)"
                                >
                                <i class="spin-sm ml-4" />
                              </span>
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div v-if="hasMarketingLicense">
                      <div class="form-row mt-4">
                        <div class="form-group col-sm-12 joinourmail">
                          <input
                              type="checkbox"
                              id="joinourmail"
                              name="joinourmail"
                              value="joinourmail"
                              v-model="JoinOurMail"
                          />
                          <label for="joinourmail">Join our mailing list!</label>
                          <p class="label">
                            By signing up you are agreeing to receive information,
                            promotional material as well as exclusive offers.
                          </p>
                        </div>
                      </div>
                    </div>
                    <div v-show="error" class="w-100 mt-4">
                      <div class="alert alert-danger" role="alert">
                        <strong v-html="error"></strong>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div id="shopping-cart" class="col-sm-5 col-xl-4">
              <ShoppingCart
                  ref="shoppingCart"
                  :isFromHomePage="false"
                  :proccessing="proccessing"
                  :order-type="orderType"
                  order-mode
              />
              <BecomeMember
                  @setBecomeMemberResult="(result) =>{
                  setBecomeMember(result)
                  }"
                  ref="becomeMember"
                  v-if="showBecomeMember"
                  @close="
                () => {
                  this.showBecomeMember = false;
                  if(canPayLater && payLaterButtonPressed){
                    payLaterClickHandler()
                  }
                }
              "
                  :isSushi="isSushi"
              />
            </div>
          </div>
        </div>
      </form>
    </div>

    <progressindicator
      v-if="!getloadedMenu"
      style="opacity: 0.4"
    ></progressindicator>

    <TermsAndCondition v-if="isSushi"  :closeModal="toggleModal" />

    <shopfooter v-else />
    <modal
      v-if="showReorderMissingMessage"
      ref="Reordermodal"
      full-header
      @close="closeReorderModal"
    >
      <template slot="body">
        <div class="container">
          <div class="d-flex justify-content-center">
            <h2 class="p-2 mt-2 privacy-header">{{ $t("message.reorder") }}</h2>
          </div>
          <p class="py-4">{{ $t("message.ReorderMessage") }}</p>
        </div>
      </template>
      <template slot="footer" class="bg-body">
        <div class="w-100" style="z-index: 2;">
          <button
            class="privacy-btn pull-right"
            data-dismiss="modal"
            type="button"
            @click="closeReorderModal()"
          >
            {{ $t("message.ok") }}
          </button>
        </div>
        <div class="privacy-footer" />
      </template>
    </modal>
    <modal
      v-if="showClearCartModal"
      ref="ClearCartModal"
      full-header
      @close="closeClearCartModal"
    >
      <template slot="body">
        <div class="container">
          <p class="py-4">{{ $t("message.clearCartMessage", {OrderType : getSelectedOrderTypeName}) }}</p>
        </div>
      </template>
      <template slot="footer" class="bg-body">
        <div class="w-100 d-flex gap-20 justify-content-center" style="z-index: 2;">
          <button
            class="privacy-btn mr-3"
            data-dismiss="modal"
            type="button"
            @click="cancelClearCart()"
          >
            {{ $t("message.cancel") }}
          </button>
          <button
            class="privacy-btn"
            data-dismiss="modal"
            type="button"
            @click="confirmClearCart()"
          >
            {{ $t("message.ok") }}
          </button>
        </div>
        <div class="privacy-footer" />
      </template>
    </modal>

    <modal ref="privacyModal" v-if="payLaterPopup" full-header @close="togglePayLaterPopup">
      <template slot="body">
        <div class="container">
          <div class="d-flex justify-content-center">
            <h2 class="p-2 mt-2 privacy-header">{{ currentStoreDoc.PayLaterPopupTitle }}</h2>
          </div>
          <p class="py-4 terms-and-conditions" v-html="currentStoreDoc.PayLaterPopupDescription"></p>
        </div>
      </template>
      <template slot="footer" class="bg-body">
        <div  style="z-index:2">
          <button
              class="privacy-btn pull-right"
              data-dismiss="modal"
              type="button"
              @click.prevent="payLaterClickHandler"
          >{{ $t("message.okayGotIt") }}</button>
        </div>
        <div class="privacy-footer" />
      </template>
    </modal>

    <TermsAndConditionsModal v-if="showTerms"   />
    </div>
</template>



<script>
import MyDetail from "./partials/MyDetail";
import ShoppingCart from "./../shopping-cart/ShoppingCart";
import DeliveryAddress from "./partials/DeliveryAddress";
import Payment from "./partials/Payment";
import PickupAddress from "./partials/PickupAddress";
import RoomDelivery from "./partials/RoomDelivery";
import EatIn from "./partials/EatIn";
import ShopHeader from "./../partials/shopheader";
import shopfooter from "./../../shared/shopfooter";
import DatePicker from "vuejs-datepicker";
import shared from "../../../sharedscripts/shop/Checkout/Checkout.js";
import BecomeMember from "../../../components/shop/register/BecomeMember";
import GooglePay from "./partials/GooglePay";
import { mapGetters, mapMutations } from "vuex";
import paymentType from "./paymentType";
import progressindicator from "../../progressindicator";
import PaymentIndicator from "../../shop/Checkout/partials/PaymentIndicator";
import modal from "../../modal";
import SushiNav from "@/components/sushiHub/sushiNav";
import TermsAndCondition from "@/components/sushiHub/termsAndCondition";
import TermsAndConditionsModal from "@/components/shop/partials/termsAndConditionsModal";
import { setUpTrackingOrderListener } from "../../../api/services/orderService.js";
import uuid from "uuid/v1";
import { orderTypeHelper } from "../../../api/helpers/orderTypeHelper.js";
export default {
  components: {
    TermsAndConditionsModal,
    TermsAndCondition,
    SushiNav,
    MyDetail,
    DeliveryAddress,
    Payment,
    PickupAddress,
    RoomDelivery,
    EatIn,
    ShoppingCart,
    ShopHeader,
    shopfooter,
    DatePicker,
    BecomeMember,
    GooglePay,
    paymentType,
    progressindicator,
    PaymentIndicator,
    modal,
  },
  props: {
    storeid: {
      type: String,
      default: "",
    },
    forGiftCart: {
      type: Boolean,
      default: false,
    },
    orderid: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      showBecomeMember: false,
      userIsExist: false,
      error: "",
      isDelivery: false,
      isPickup: false,
      isChargeToRoom: false,
      isEatIn: false,
      showTerms: false,
      dtimes: [],
      pickupTimes: [],
      selectedDeliveryTime: "",
      selectedPickupTime: "",
      deliveryDate: "",
      pickupDate: "",
      startdate: "",
      notes: "",
      deliveryDisabledDates: {},
      pickupDisabledDates: {},
      showClearCartModal: false,
      lastOrderTypeSelected: "",
      newOrderType: "",
      nextOrderType: "",
      detailModel: {
        FirstName: "",
        LastName: "",
        Email: "",
        Phone: "",
      },
      paymentModel: {
        CardHolder: "",
        CardNumber: "",
        ExpireDate: "",
        CVV: "",
        SelectedCard: null,
      },
      deliveryAddressModel: {
        StreetAddress: "",
        PostalCode: "",
        CityTown: "",
        DeliveryInstructions: "",
        State: "",
        Latitude: "",
        Longitude: "",
      },
      roomDeliveryModel: {
        RoomNumber: "",
      },
      eatInModel: {
        TableNumber: "",
        FirstName: "",
        LastName: "",
        Email: "",
        PhoneNumber: "",
        DineInField: "",
      },
      registerNew: false,
      saveCard: false,
      JoinOurMail: true,
      paymentMethod: 1,
      deliveryDisabled: false,
      pickupDisabled: false,
      userInfo: {},
      proccessing: false,
      showPaymentIndicator: false,
      paymentSucceeded: true,
      placingPayLaterOrder: false,
      orderObject: null,
      guestUserId: null,
      googleLoaded: false,
      disableStripeBtn: false,
      stripeToken: null,
      PaymenttypeRender: 0,
      canPayByApple: false,
      canPayByGoogle: false,
      AcceptTermsAndCondition: false,
      turnAcceptLabelToRed: false,
      showReorderMissingMessage: false,
      payLaterPopup : false,

      // used to check if user has clicked pay later button to skip prevent clicked twice
      payLaterButtonPressed :false,
      unsubscribe: null
    };
  },

  computed: {
    ...shared.computed,
    ...mapGetters([ "desktopStyles"]),
    orderButtonStyles() {
      return {
        ...this.desktopStyles.btn,
        ...this.desktopStyles.desktopPlaceOrderButton,
      };
    },
    orderDisbaled() {
      return (
        !this.exceedMinPurchase ||
        this.proccessing ||
        this.cartItems.length === 0
      );
    },
    hasMarketingLicense() {
      const store = this.currentStoreDoc;

      if(store && typeof store === 'object') {
        return store.EnableLoyaltyMarketing;
      } else {
        return false;
      }
    },
    isPayByCard() {
      return !this.viewConfig.PayLaterOnly || !this.isEatIn
    },
    isSushi(){
      return this.hqDoc && this.hqDoc.IsSushiHub
    }
  },
  watch: {
    ...shared.watch,
    holder() {
      this.paymentModel.CardHolder = this.holder;
    },
    pickupDate() {
      if (this.isPickup) this.pickupSurcharge();
    },
    deliveryDate() {
      if (this.isDelivery) this.deliverySurcharge();
    },
    dbuser(newVal) {
      if(
        newVal == null &&
        this.selectedCompany.ViewComponentConfigs.LogIn &&
        this.selectedCompany.ViewComponentConfigs.LogInMandatory
      ) {
        this.$router.push({
          name: "store",
          params: { storeid: this.storeid },
        });
      } else {
        this.userInfo = this.dbuser;
        this.initModel();
      }
    },
    getDeliveryDuration() {
      this.setDeliveryTimes(this.deliveryDate);
    },
    getTotalPrice() {
      this.orderIdentifier = uuid();
      this.remountStripeButton();
    },
    pickupTimes() {
      this.checkStoreClosed();
    },
    dtimes() {
      this.checkStoreClosed();
    },
    "selectedCompany.DeliveryTimeInterval" : function (){
        this.setPickupDeliveryDates();
     },
    "selectedCompany.PickupTimeInterval" : function (){
      this.setPickupTimes(this.pickupDate);
     },
    selectedDeliveryTime() {
      console.log('line 894', {selectedDeliveryTime: this.selectedDeliveryTime})
      orderTypeHelper.setDeliveryTime(
        new Date(this.selectedDeliveryTime).toISOString()
      );
    },
    selectedPickupTime() {
      console.log('line 899', {selectedPickupTime: this.selectedPickupTime})
      orderTypeHelper.setDeliveryTime(
        new Date(this.selectedPickupTime).toISOString()
      );
    },

    // payButtonsAreDisabled(newValue) {
    //   if (newValue === false) {
    //     this.paymentMethod = this.$refs.stripePayRef.applePay ? 6 : 7;
    //     this.remountStripeButton();
    //   }
    // },
  },
  created() {
    this.setRoomNoFromStorage();
  },
  async mounted() {
    await shared.mounted(true, this);

    setUpTrackingOrderListener(this);
  },
  beforeRouteEnter(to, from, next) {
    shared.beforeRouteEnter(to, from, next);
  },
  methods: {
    ...shared.methods,
    ...mapMutations(["setShowOverlay"]),
    setCanPayByApple(flag) {
      this.canPayByApple = flag;
    },
    setCanPayByGoogle(flag) {
      this.canPayByGoogle = flag;
    },
    closeReorderModal() {
      this.$refs.Reordermodal.hideModal();
      this.showReorderMissingMessage = false;
    },
    closeClearCartModal() {
      this.$refs.ClearCartModal.hideModal();
      this.showClearCartModal = false;
      this.cancelClearCart();
    },

    setBecomeMember(result) {
      this.setBecomeMemberResult(result)
      this.showBecomeMember = false;
      if(this.canPayLater && this.payLaterButtonPressed){
        this.payLaterClickHandler()
      }

    },

    toggleModal (){
      this.showTerms = !this.showTerms;
    }
  },
  destroyed() {
    shared.destroyed();
  },
  beforeDestroy() {
    shared.beforeDestroy(this);
  }
};
</script>
